export class Error {
    public title: string;
    public description: string;

    public constructor(init?: Partial<Error>) {
        Object.assign(this, init);
    }
}
